import { render } from "./CompetiotionsMarketCell.vue?vue&type=template&id=5425c642&scoped=true"
import script from "./CompetiotionsMarketCell.vue?vue&type=script&lang=js"
export * from "./CompetiotionsMarketCell.vue?vue&type=script&lang=js"

import "./CompetiotionsMarketCell.vue?vue&type=style&index=0&id=5425c642&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5425c642"]])

export default __exports__